//react component that shows tabs to navigate between graph views
import Button from "@mui/material/Button";

const TabNavigator = (propsNavigator) => {
    const TabItem = (props) => {
        return (
            <div className="mx-1">
                <Button variant={propsNavigator.currentTab === props.viewName ? "contained" : "outlined"}
                        sx={{color: propsNavigator.currentTab === props.viewName ? "#FFFFFF" : "#000000"}}
                        color="bgdark"
                        onClick={ e => {
                    propsNavigator.setTab(props.viewName)
                        }}>{props.children}</Button>
            </div>
        )
    }
    return(
        <div className="absolute top-2 left-2 p-4 rounded flex z-5 bg-neutral-100">
            <TabItem viewName="social">Social View</TabItem>
            <TabItem viewName="spatial">Spatial View</TabItem>
            <TabItem viewName="combined">Combined View</TabItem>
        </div>
    )
}



export default TabNavigator;